import { ArrowNarrowRightIcon } from "@heroicons/react/outline";
import { Document } from "@prismicio/client/types/documents";
import { ButtonLink } from "components/Button";
import i18n from "i18next";
import readTime from "lib/readTime";
import Image from "next/image";
import Link from "next/link";
import { RichText } from "prismic-reactjs";
import React from "react";

export default function FeaturedArticle({ article }: { article: Document }) {
  return (
    <div className="max-w-lg sm:max-w-3xl lg:max-w-7xl w-full mx-auto">
      <div className="bg-gray-900 rounded-lg shadow-xl overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
        <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
          <div className="lg:self-center">
            <div className="flex space-x-1 text-sm text-gray-100">
              {article.first_publication_date && (
                <>
                  <time dateTime={article.first_publication_date}>
                    {new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }).format(new Date(article.first_publication_date))}
                  </time>
                  <span aria-hidden="true">&middot;</span>
                </>
              )}
              <span>{readTime(article)} min read</span>
            </div>
            <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
              {RichText.asText(article.data.title)}
            </h2>
            <p className="mt-4 text-lg leading-6 text-gray-200">{article.data.summary}</p>
            <Link href={`/blog/article/${article.uid}`}>
              <ButtonLink
                href={`/blog/article/${article.uid}`}
                title={i18n.t("Continue reading")}
                className="mt-8 inline-flex items-center w-auto"
                icon={<ArrowNarrowRightIcon className="ml-2 -mr-0.5 h-6 w-6" aria-hidden="true" />}
              />
            </Link>
          </div>
        </div>
        <div className="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
          <div className="transform translate-x-6 translate-y-6 rounded-md sm:translate-x-16 lg:translate-y-20">
            <Image
              src={article.data.cover_image.url}
              alt={article.data.cover_image.alt || article.data.title[0].text}
              layout="fill"
              objectFit="cover"
              objectPosition="left top"
              className="rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
